import { Group, Skeleton, Stack, Table, Text } from '@mantine/core';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { LIGHT_GREY } from '../../const/constants';
import { query } from '../../util/api/query';
import { EditableVatRow } from './components/EditableVatRow';
import type { VatRateDto } from './types/VatRateDto';
import { KeyedRow } from '../../components/KeyedRow';

export function VatRates() {
	const { organisation } = useParams();

	const vatRatesQuery = query<VatRateDto[]>(`${organisation}/vat-rates/all`);

	useEffect(() => {
		document.body.style.backgroundColor = LIGHT_GREY;
	}, []);

	const vatRates = useMemo(() => {
		return (
			vatRatesQuery.data?.value.sort(
				(a, b) => Number.parseInt(a.id) - Number.parseInt(b.id),
			) ?? []
		);
	}, [vatRatesQuery.data?.value]);

	return (
		<>
			<PageHeader title={'VAT Rates'} isCentered hideFiltering />
			<Stack w={'100%'} align="center">
				<DataTable width={'100%'}>
					<Table.Thead>
						<KeyedRow px={10}>
							<Table.Th />
							<Table.Th><Title label={'ID'} /></Table.Th>
							<Table.Th><Title label={'Description'} /></Table.Th>
							<Table.Th><Title label={'Rate'} /></Table.Th>
							<Table.Th>
								<Group justify={'center'}>
									<Text fw={'bold'} size="sm" lineClamp={1}>
										After Vat {'(Â£100)'}
									</Text>
								</Group>
							</Table.Th>
							<Table.Th w={'10vw'}>
								<Group justify={'center'}>Edit</Group>
							</Table.Th>
						</KeyedRow>
					</Table.Thead>
					<Table.Tbody>
						{vatRates.map((vatRate) => (
							<EditableVatRow initialVatRate={vatRate} />
						))}
						{vatRatesQuery.isLoading &&
							Array(9)
								.fill(0)
								.map(() => (
									<KeyedRow h={'7vh'} px={10}>
										<Table.Td colSpan={9}>
											<Skeleton w={'100%'} h={'5vh'} />
										</Table.Td>
									</KeyedRow>
								))}
					</Table.Tbody>
				</DataTable>
			</Stack>
		</>
	);
}
